/** Canonical form used for email join keys and access document ids. */
export default function normalizeEmail(email?: string | null): string {
  return typeof email === 'string' ? email.toLowerCase().trim() : '';
}

/** Safe deterministic document id for the contact-email uniqueness reservation. */
export function emailIndexId(email?: string | null): string {
  return encodeURIComponent(normalizeEmail(email));
}
